
/* ============================== src/components/Gantt/tree.js ============================== */
// src/components/Gantt/tree.js
// Дерево задач и порядок строк с учётом зависимостей и раскрытия.

export const buildTaskTree = (tasks) => {
  const map = {};
  const roots = [];
  tasks.forEach((t) => {
    map[t.id] = { ...t, children: [] };
  });
  tasks.forEach((t) => {
    const parentId = t.parentTaskId ? String(t.parentTaskId) : null;
    if (parentId && map[parentId]) map[parentId].children.push(map[t.id]);
    else roots.push(map[t.id]);
  });
  const sortChildren = (node) => {
    node.children.sort((a, b) => (a.start || "").localeCompare(b.start || ""));
    node.children.forEach(sortChildren);
  };
  roots.forEach(sortChildren);
  return roots;
};

export const flattenTree = (nodes, level = 0, acc = []) => {
  nodes.forEach((node) => {
    acc.push({ ...node, level, hasChildren: node.children.length > 0 });
    flattenTree(node.children, level + 1, acc);
  });
  return acc;
};

/**
 * Порядок строк внутри проекта.
 *
 * Правило reorder по зависимостям применяется ТОЛЬКО к корневым задачам.
 * Обоснование: подзадача живёт внутри поддерева родителя; её перестановка
 * в чужой поддерево ломала бы иерархию. Корневая задача с dependencyId
 * встаёт сразу после своего предшественника - так визуально видна
 * цепочка «A → B → C».
 */
export const buildRowOrder = (tasks, expandedTasks) => {
  const tree = buildTaskTree(tasks);
  const nodeById = new Map();
  const walk = (n) => {
    nodeById.set(n.id, n);
    n.children.forEach(walk);
  };
  tree.forEach(walk);

  const successorsOf = new Map();
  for (const root of tree) {
    if (!root.dependencyId) continue;
    const pred = nodeById.get(root.dependencyId);
    if (!pred || pred.parentTaskId) continue; // правило выше
    const list = successorsOf.get(pred.id) || [];
    list.push(root);
    successorsOf.set(pred.id, list);
  }
  for (const list of successorsOf.values()) {
    list.sort(
      (a, b) =>
        (a.start || "").localeCompare(b.start || "") ||
        a.id.localeCompare(b.id),
    );
  }

  const order = [];
  const visited = new Set();
  const traverse = (node, level) => {
    if (visited.has(node.id)) return;
    visited.add(node.id);
    order.push({
      id: node.id,
      level,
      hasChildren: node.children.length > 0,
      node,
    });
    for (const s of successorsOf.get(node.id) || []) traverse(s, level);
    if (expandedTasks.has(node.id))
      node.children.forEach((child) => traverse(child, level + 1));
  };
  tree.forEach((root) => traverse(root, 0));
  return order;
};
